import { GridFilterItem } from '@mui/x-data-grid-pro';

import { QueryOption } from '../@types';
import { httpClient, HttpMethod } from './http-client';
import {
  MerchantDamagePartAdditionalData,
  MerchantDamageTemplateQuery,
  MerchantDamagePartSerialQueryData,
  PartListResponse,
  NSPartLocationList,
  SerailizedPartsList,
} from '../@types/part.type';

// Response type for part additional data update
interface PartAdditionalDataResponse {
  id: number;
  success: boolean;
}

export const getAllParts = (queryOptions: QueryOption, serialSearch?: string, excludedColumns?: string, obfuscation?: string): Promise<PartListResponse> => {
  const { filterModel, page, pageSize, sortModel } = queryOptions;
  let url = `/parts?page=${page + 1}&limit=${pageSize}&serial_search=${serialSearch}&excludedColumns=${excludedColumns}`;

  if (sortModel && sortModel[0] && sortModel[0].field) {
    url += `&order_by=${sortModel[0].field}&order_direction=${sortModel[0].sort}`;
  }

  filterModel.items?.forEach((filter: GridFilterItem) => {
    const field = filter?.field;
    const operator = filter?.operator;
    const value = filter?.value ?? '';
    url += `&${field}=${operator},${value}`;
  });

  if (obfuscation) {
    url += `&obfuscation=${obfuscation}`;
  }

  return httpClient<PartListResponse>(url, HttpMethod.Get);
};

export const getNSPartByPartTypeAndLocation = (partTypeId: number, locationId: number, isReturn: boolean = false, isIncludeLocationChildren: boolean = false): Promise<NSPartLocationList[]> => {
  return httpClient<NSPartLocationList[]>(`/nsparts/search?partTypeId=${partTypeId}&locationId=${locationId}&isReturn=${isReturn}&isIncludeLocationChildren=${isIncludeLocationChildren}`, HttpMethod.Get);
};

export const getPartsLogAgainstService = (serviceId: number, locationTypeCode: string): Promise<SerailizedPartsList[]> => {
  return httpClient<SerailizedPartsList[]>(`/partsLogAgainstService/${serviceId}?locationTypeCode=${locationTypeCode}`, HttpMethod.Get);
};

export const getMerchantDamagePartSerialData = (queryOptions: MerchantDamageTemplateQuery): Promise<MerchantDamagePartSerialQueryData[]> => {
  const { serviceId, mainLocationNodeId } = queryOptions;
  const url = `/partHistory/${serviceId}/location/${mainLocationNodeId}/outPartActions`;
  return httpClient<MerchantDamagePartSerialQueryData[]>(url, HttpMethod.Get);
};

export const updatePartAdditionalData = (queryOptions: MerchantDamagePartAdditionalData, partId: number): Promise<PartAdditionalDataResponse> => {
  const url = `/parts/${partId}/additionalData/merchantDamageData`;
  return httpClient<PartAdditionalDataResponse>(url, HttpMethod.Put, queryOptions);
};